/* app/js/src/components/common/button/button.component.scss */
button.black:hover,
button.dark {
  color: #232f3a;
}
button.white {
  color: #ffffff;
}
.cursor-pointer {
  cursor: pointer;
}
button {
  background: none;
  border: none;
  padding: 6px 9px 7px 9px;
  font-size: 0.85em;
  border: 1px solid #879baf;
  border-radius: 4px;
  min-width: 75px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
button span:last-child {
  color: #232f3a;
}
button:focus {
  outline-color: #ffffff;
}
button.icon {
  border: none;
}
button.icon:focus {
  outline: none;
}
button.dark {
  background-color: #232f3a;
  color: #ffffff;
}
button.dark span:last-child {
  color: #ffffff;
}
button.green {
  background-color: #1de9b6;
  border-color: #1de9b6;
}
button.brigth:hover {
  background-color: #ffffff;
  border-color: #ffffff;
}
button.black {
  background-color: black;
}
button.black .label {
  color: white;
}
button.black:hover {
  background-color: #232f3a;
  color: #ffffff;
}
button.disabled {
  color: #6d7780;
  background-color: #e1e6eb;
  border: 1px solid #dde3e7;
  font-weight: 600;
  cursor: not-allowed;
}
button.disabled span {
  color: #ffffff;
}
button.white {
  background-color: #ffffff;
  border-color: #ffffff;
  color: #40c4ff;
}
button.warning {
  background-color: #ef5350;
  border-color: #ef5350;
  color: #ffffff;
}
button.warning span {
  color: #ffffff;
}
button.icon {
  color: #879baf;
}
button.icon span.icon {
  font-size: 1.8em;
  color: inherit;
  display: block;
  -ms-transform: translateY(2px);
  -webkit-transform: translateY(2px);
  transform: translateY(2px);
}
button.icon span.reactive {
  color: #879baf;
  -ms-transform: scale(1);
  -webkit-transform: scale(1);
  transform: scale(1);
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
button.icon span.reactive:active {
  -ms-transform: scale(0.7);
  -webkit-transform: scale(0.7);
  transform: scale(0.7);
  color: #232f3a;
}
button.icon:active {
  color: #232f3a;
}
/*# sourceMappingURL=button.component.css.map */
